'use strict';
import AbstractChart from './abstract-chart';

export default class ChordDiagram extends AbstractChart {
  constructor(targetElementId) {
    super();
    this.targetElementId = targetElementId;
    this.filterSubject.next([
      {key: 'categories', value: 'genres', label: 'Genres', active: true, type: 'radio', position: 'category'},
      {key: 'categories', value: 'explicit_genres', label: 'Explicit Genres', type: 'radio', position: 'category'},
      {key: 'categories', value: 'themes', label: 'Themes', type: 'radio', position: 'category'},
      {key: 'categories', value: 'demographics', label: 'Demographics', type: 'radio', position: 'category'},
      {key: 'dated_at', value: 'wrap_up_year', label: 'Wrap-Up', type: 'check', position: 'filter'},
      {key: 'dated_at', value: 'past_year', label: 'Past Year', type: 'check', position: 'filter'},
      {key: 'dated_at', value: 'custom', label: 'Custom Time', type: 'picker', position: 'filter'},
      {key: 'score', value: '', label: 'List Score', type: 'select', position: 'filter'},
    ]);
    this.subscribes = [];
    this.preparedColors = [
      '#487FD1', // 7
      '#F3CF4C', // 16
      '#E065A0', // 11
      '#ABE44E', // 1
      '#00B5C1', // 4
      '#FAA352', // 15
      '#67CD38', // 2
      '#8B78C3', // 9
      '#D965D4', // 12
      '#6DD8E7', // 5
      '#56AA6D', // 3
      '#E85454', // 13
      '#61ADD8', // 6
      '#CD8E72', // 14
      '#859DF2', // 8
      '#CAA4FB', // 10
    ];
  }

  renderChart() {
    if (!document.getElementById(this.targetElementId)) {
      throw new DOMException(`Target Element Id (${this.targetElementId}) not found.`);
    }

    const chart = am4core.create(`${this.targetElementId}-diagram`, am4charts.ChordDiagram);
    this.chart = chart;
    chart.paddingTop = '50px';
    chart.paddingBottom = '50px';
    this.is_dummy = document.querySelector(`#${this.targetElementId}`).dataset.isDummy;
    this.endpoint = document.querySelector(`#${this.targetElementId}`).dataset.endpoint + (this.is_dummy ? '&is_dummy=true' : '');
    chart.dataSource.url = this.endpoint;
    // ここで入ってきたデータの処理を行う
    this.manipulateDataSource();
    this.noDataIndicator.createNoDataIndicator(this.chart);

    chart.dataFields.fromName = 'from';
    chart.dataFields.toName = 'to';
    chart.dataFields.value = 'value';
    chart.dataFields.color = 'nodeColor';
    chart.dataFields.linkTooltipText = 'linkTooltipText';

    chart.nodePadding = 0.8;
    chart.minNodeSize = 0.02;
    chart.startAngle = 0;
    chart.endAngle = chart.startAngle + 360;
    chart.sortBy = 'value';
    chart.fontSize = 12;
    chart.tooltip.label.fontSize = 14;
    chart.preloader.disabled = true;

    const nodeTemplate = chart.nodes.template;
    nodeTemplate.showSystemTooltip = true;
    nodeTemplate.propertyFields.fill = 'color';
    nodeTemplate.tooltipText = '{name}';
    nodeTemplate.clickable = false;
    nodeTemplate.draggable = false;

    // when rolled over the node, make all the links rolled-over
    nodeTemplate.events.on('over', function(event) {
      const node = event.target;
      node.outgoingDataItems.each(function(dataItem) {
        if (dataItem.toNode) {
          dataItem.link.isHover = true;
          dataItem.toNode.label.isHover = true;
        }
      });
      node.incomingDataItems.each(function(dataItem) {
        if (dataItem.fromNode) {
          dataItem.link.isHover = true;
          dataItem.fromNode.label.isHover = true;
        }
      });

      node.label.isHover = true;
    });

    // when rolled out from the node, make all the links rolled-out
    nodeTemplate.events.on('out', function(event) {
      const node = event.target;
      node.outgoingDataItems.each(function(dataItem) {
        if (dataItem.toNode) {
          dataItem.link.isHover = false;
          dataItem.toNode.label.isHover = false;
        }
      });
      node.incomingDataItems.each(function(dataItem) {
        if (dataItem.fromNode) {
          dataItem.link.isHover = false;
          dataItem.fromNode.label.isHover = false;
        }
      });

      node.label.isHover = false;
    });

    const label = nodeTemplate.label;
    label.relativeRotation = 90;

    label.fillOpacity = 0.5;
    let labelHS = label.states.create('hover');
    labelHS.properties.fillOpacity = 1;

    // link template
    const linkTemplate = chart.links.template;
    linkTemplate.strokeOpacity = 0;
    linkTemplate.fillOpacity = 0.15;
    linkTemplate.tooltipText = '{linkTooltipText}';

    const hoverState = linkTemplate.states.create('hover');
    hoverState.properties.fillOpacity = 0.9;
    hoverState.properties.strokeOpacity = 0.9;

    return chart;
  }

  renderChordDiagram() {
    this.renderChart();
    const $filter_block = $(document.querySelector(`#${this.targetElementId}-filters`));
    const $button_tmpl = $.templates('#statistics-filter-button');
    this.renderFilterButtons($filter_block, $button_tmpl, ([prev, filters]) => {
      if (prev) { // 初回のみnullが来るのでロードしない
        this.chart.dataSource.load();
      }

      if ($filter_block.hasClass('disabled')) {
        const $malButtonElements = $('.mal-btn', $filter_block);
        $malButtonElements.each(function() {
          $(this).prop('disabled', true);
        });
      }
    });
  }

  finishLoading() {
    const loading = $(`#${this.targetElementId}-loading`);
    if (!loading.hasClass('hidden')) {
      loading.addClass('hidden');
      document.dispatchEvent(new Event('statistics_loaded'));
    }
  }

  manipulateDataSource() {
    // まだやらないけど、ここからmean, std dev, totalを取り出す
    this.chart.dataSource.events.on('parseended', (ev) => {
      const data = ev.target.data;
      // もしデータ量が足りてなかった場合は、足りないアラートを出す
      if (data.is_lt_10_title || data.is_complete_title_lt_5 || !data.result) {
        $(`#${this.targetElementId}-nodata`).removeClass('hidden');
        $(`#${this.targetElementId}`).closest('.chart-root').addClass('nodata');
        $(`#${this.targetElementId}`).closest('.chart-root').find('.sp-toggle-filter-btn').prop('disabled', true);
      }
      if ($(`#${this.targetElementId}`).data('is-dummy')) {
        $(`#${this.targetElementId}`).closest('.chart-root').find('.sp-toggle-filter-btn').prop('disabled', true);
      }
      const items = data.result ? data.items : [];
      // 色データ入れる
      const colors = Array.from(new Set(items.map(i => i.from))).map((genre, index) => {
        return {from: genre, nodeColor: this.preparedColors[index % this.preparedColors.length]};
      });
      if (items.length === 0) {
        this.noDataIndicator.showNoDataIndicator();
        return;
      } else {
        this.noDataIndicator.hideNoDataIndicator();
      }
      ev.target.data = colors.concat(items.map(item => ({
        ...item,
        linkTooltipText: (item.from_id === item.to_id) ? `${item.from} only: ${item.value}` : `${item.from} & ${item.to}: ${item.value}`
      })));
      this.finishLoading();
    });
    this.chart.dataSource.adapter.add('url', (url) => {
      const query = new URLSearchParams(this.toParamFilter(this.filterSubject.value));
      return `${url}&${query}`;
    });
  }
}
